import React from 'react';
import './cta.css'

const Cta = (props) => {
    return ( 
        <button className={props.stylee}>
            {props.title}
        </button>
     );
}
 
export default Cta;